module.exports = __webpack_public_path__ + "img/role_jlsy.9efe5d37.jpg";